import React from 'react';

import { withTranslation } from 'providers/GILT.provider';

import ActivityFeedIcon from 'activity/components/ActivityFeedIcon';
import Footer from 'activity/components/ItemFooter';

export class TodaysOverview extends React.Component {
  markAsRead = () => {
    this.props.onReadToggle(!this.props.seen);
  };
  render() {
    const t = this.props.t;
    return (
      <div className="comment-content 4">
        <div className="feed-text">
          <div className={!this.props.seen ? 'new-item-indicator available' : 'new-item-indicator'} />
          <div className="client-name">
            <ActivityFeedIcon iconName="ico-announcement" />
            {t('composite.activityFeed.todaysOverview.title')}
          </div>

          <div className="notes-sheet">
            <dl className="dl-horizontal cfix">
              <dt>{t('composite.activityFeed.todaysOverview.totalBookings')}</dt>
              <dd>12</dd>
              <dt>{t('composite.activityFeed.todaysOverview.onlineBookings')}</dt>
              <dd>8</dd>
              <dt>{t('composite.activityFeed.todaysOverview.confirmed')}</dt>
              <dd>6</dd>
              <dt>{t('composite.activityFeed.todaysOverview.cancelled')}</dt>
              <dd>2</dd>
              <dt>{t('composite.activityFeed.todaysOverview.missedCalls')}</dt>
              <dd>2</dd>
              <dt>{t('composite.activityFeed.todaysOverview.patchTest')}</dt>
              <dd>1</dd>
            </dl>
          </div>
          <section className="overview">
            <dl className="dl-horizontal cfix">
              <dt>{t('composite.activityFeed.todaysOverview.needConfirmation')}</dt>
              <dd>2</dd>
            </dl>
            <ul>
              <li>
                <h5>{t('composite.activityFeed.todaysOverview.name1')}</h5>
                <span>{t('composite.activityFeed.todaysOverview.call')}</span>
              </li>
              <li>
                <h5>{t('composite.activityFeed.todaysOverview.name2')}</h5>
                <span>{t('composite.activityFeed.todaysOverview.call')}</span>
              </li>
            </ul>
          </section>
          {/* <section className="overview">
            <dl className="dl-horizontal cfix">
              <dt>Cancelled</dt>
              <dd>1</dd>
            </dl>
            <ul>
              <li>
                <h5>Slumdog Millionaire</h5>
              </li>
            </ul>
          </section> */}
        </div>
        <Footer seen={this.props.seen} markAsRead={this.markAsRead} timestamp={this.props.timestamp} />
      </div>
    );
  }
}

const TodaysOverviewHoc = withTranslation(TodaysOverview);

export default TodaysOverviewHoc;
